document.addEventListener('DOMContentLoaded', async () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('kquoteUpdate') !== '1') return;

  const raw = localStorage.getItem('kaboomQuoteUpdateRequest');
  if (!raw) return;

  let request;
  try {
    request = JSON.parse(raw);
  } catch (e) {
    console.error('[Quote Update] Bad request', e);
    return;
  }

  const quote = request.quote;
  const quoteIndex = request.quoteIndex;
  const newQuantity = request.newQuantity;

  if (!quote || quoteIndex === undefined || !newQuantity) return;

  const overlay = document.createElement('div');
  overlay.innerHTML = `
    <div id="kaboom-quote-update-overlay">
      <div class="kaboom-quote-update-box">
        <div class="kaboom-quote-update-spinner"></div>
        <h3>Updating quote</h3>
        <p>Recalculating pricing...</p>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  const style = document.createElement('style');
  style.textContent = `
    #kaboom-quote-update-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.7);
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .kaboom-quote-update-box {
      background: white;
      padding: 32px;
      border-radius: 20px;
      text-align: center;
      width: min(360px, calc(100% - 40px));
    }
    .kaboom-quote-update-spinner {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 5px solid rgba(0,0,0,0.1);
      border-top-color: #8ab7aa;
      margin: 0 auto 20px;
      animation: spin 0.8s linear infinite;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);

  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

  function setNativeValue(element, value) {
    if (!element) return;

    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
      prototypeValueSetter.call(element, value);
    } else if (valueSetter) {
      valueSetter.call(element, value);
    } else {
      element.value = value;
    }

    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  await wait(1200);

  const numberInput = document.getElementById('calc-quantity-number');
  const colourSelect = document.getElementById('calc-colour');
  const decoSelect = document.getElementById('calc-decoration');

  if (numberInput) {
    setNativeValue(numberInput, newQuantity);
    numberInput.dispatchEvent(new Event('blur', { bubbles: true }));
  }

  await wait(600);

  if (colourSelect && quote.colour) {
    const colourOption = Array.from(colourSelect.options).find(opt =>
      opt.value.trim().toLowerCase() === String(quote.colour).trim().toLowerCase()
    );

    if (colourOption) {
      colourSelect.value = colourOption.value;
      colourSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  await wait(600);

  if (decoSelect && quote.decorationValue) {
    const decoOption = Array.from(decoSelect.options).find(opt =>
      opt.value.trim().toLowerCase() === String(quote.decorationValue).trim().toLowerCase()
    );

    if (decoOption && !decoOption.disabled) {
      decoSelect.value = decoOption.value;
      decoSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  await wait(1500);

  let unitFullText = document.querySelector('#calc-price-display .unit-price')?.textContent || '';
  let totalFullText = document.querySelector('#calc-price-display .total-price')?.textContent || '';

  let tries = 0;
  while (
    tries < 10 &&
    (!unitFullText || !totalFullText || unitFullText.includes('N/A') || totalFullText.includes('N/A'))
  ) {
    await wait(500);
    unitFullText = document.querySelector('#calc-price-display .unit-price')?.textContent || '';
    totalFullText = document.querySelector('#calc-price-display .total-price')?.textContent || '';
    tries++;
  }

  if (!unitFullText || !totalFullText) {
    alert('Sorry, the price could not be recalculated. Please try again.');
    localStorage.removeItem('kaboomQuoteUpdateRequest');
    window.location.href = window.location.pathname + '?basketOpen=1';
    return;
  }

  const cleanTotal =
    Number(window.currentRoundedUnitPrice || 0) * Number(window.currentQty || newQuantity);

  const vatAmount = Math.round(cleanTotal * 0.2 * 100) / 100;
  const grandTotal = Math.round(cleanTotal * 1.2 * 100) / 100;

  let decoText = decoSelect?.value
    ? decoSelect.options[decoSelect.selectedIndex].text
    : quote.decoration;

  if (window.decorationGuidance) {
    decoText += ` ${window.decorationGuidance}`;
  }

  const updatedQuote = {
    ...quote,
    quantity: numberInput?.value || newQuantity,
    decoration: decoText,
    unitCost: unitFullText.replace(/^Unit Price:\s*/, '').trim(),
    totalExc: totalFullText.replace(/^Total:\s*/, '').trim(),
    vat: '£' + vatAmount.toFixed(2),
    totalInc: '£' + grandTotal.toFixed(2),
    baseCostWithFixed: window.currentBaseCostWithFixed || quote.baseCostWithFixed || 0,
    individualTotalExc: window.currentIndividualTotalExc || cleanTotal || quote.individualTotalExc || 0
  };

  const quotes = JSON.parse(localStorage.getItem('quoteBasket') || '[]');
  quotes[quoteIndex] = updatedQuote;

  localStorage.setItem('quoteBasket', JSON.stringify(quotes));
  localStorage.removeItem('kaboomQuoteUpdateRequest');

  window.location.href = window.location.pathname + '?basketOpen=1';
});